import React, { useState } from "react";
import { useTts } from 'react-tts';// Import useTts hook from react-tts

const Slokcard = (props) => {
  const { speak } = useTts(); // Use the useTts hook from react-tts
  const [loading] = useState(false);
  const [filter, setFilter] = useState("both"); // State to track filter selection

  // Function to toggle filter
  const toggleFilter = () => {
    setFilter(filter === "hindi" ? "english" : filter === "english" ? "both" : "hindi");
  };

  // Function to check if meaning should be displayed based on filter
  const shouldDisplayMeaning = (meaning) => {
    return filter === "both" || (filter === "hindi" && meaning === props.data.tej?.ht) || (filter === "english" && meaning === props.data.gambir?.et);
  };
  const speakSlowly = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.8;

    // Fetch the list of available voices
    const voices = window.speechSynthesis.getVoices();

    // Find a female voice
    const femaleVoice = voices.find(voice => voice.name.includes('female'));

    // If a female voice is found, set it
    if (femaleVoice) {
      utterance.voice = femaleVoice;
    }

    speak(utterance);
  };

  return (
    <div
      className="card mt-4 p-2 mb-4 border-danger"
      data-aos="fade-left"
      data-aos-duration={2000}
    >
      <div className="card-header text-center">
        {props.t ? "श्लोक" : "आज का श्लोक"}
        {/* Filter toggle button */}
        <button style={{ marginLeft: '1rem' }} className="btn btn-sm btn-outline-secondary ml-2" onClick={toggleFilter}>
          {filter === "hindi" ? "हिंदी" : filter === "english" ? "English" : "Both"}
        </button>
      </div>
      <div className="card-body mt-4 pt-4">
        <div className="card-text">
          {loading ? (
            <p className="text-center">
              <i className="fas fa-spinner fa-2x fa-spin"></i>
            </p>
          ) : (
            <figure className="text-center">
              <blockquote className="blockquote">
                <p className="slok">
                  <b>{props.data.slok}</b>
                </p>
              </blockquote>
              {/* Display meanings based on filter */}
              {shouldDisplayMeaning(props.data.tej?.ht) && (
                <blockquote className="blockquote">
                  <p className="slokmeaning">{props.data.tej?.ht}</p>
                </blockquote>
              )}
              {shouldDisplayMeaning(props.data.gambir?.et) && (
                <blockquote className="blockquote">
                  <p className="slokmeaning">{props.data.gambir?.et}</p>
                </blockquote>
              )}
              <figcaption className="blockquote-footer mt-4 pt-4">
                Bhagavad Gita &nbsp;
                <cite title="Source Title">
                  Chapter &nbsp; {props.data.chapter} . {props.data.verse}
                  <hr />
                  {/* Text-to-speech buttons */}
                  <button
                    className="btn btn-outline-success"
                    onClick={() => speakSlowly(props.data.slok)}
                  >
                    <i className="fab fa-whatsapp-square fa-2x"></i> whatsaap
                  </button>
                  &nbsp;
                  {shouldDisplayMeaning(props.data.tej?.ht) && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => speakSlowly(props.data.tej?.ht)}
                    >
                      <i className="fa-solid fa-volume-high"></i> Speak Hindi
                    </button>
                  )}
                  &nbsp;
                  {shouldDisplayMeaning(props.data.gambir?.et) && (
                    <button
                      className="speak-button"
                      onClick={() => speakSlowly(props.data.gambir?.et)}
                    >
                      <i class="fa-solid fa-volume-high"></i> Speak English
                    </button>
                  )}
                </cite>
              </figcaption>
            </figure>
          )}
        </div>
      </div>
    </div>
  );
};

export default Slokcard;
